import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import StyledImage, { StyledLazyImage, PlaceholderImageWrapper, PlaceholderImage } from "./Image";
import { useInView } from "./useInView";
var propTypes = {
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  crop: PropTypes.bool,
  circle: PropTypes.bool,
  fluid: PropTypes.bool,
  src: PropTypes.string,
  placeholderSrc: PropTypes.string
};

function LazyImage(_ref) {
  var props = _extends({}, _ref);

  var imageRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inView = _useState2[0],
      setInView = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoaded = _useState4[0],
      setIsLoaded = _useState4[1];

  var lazyImage = React.createElement(StyledLazyImage, Object.assign({}, props, {
    ref: imageRef,
    onLoad: function onLoad() {
      return setIsLoaded(true);
    },
    isLoaded: isLoaded
  }));
  var placeholder = React.createElement(PlaceholderImageWrapper, props, React.createElement(PlaceholderImage, {
    ref: imageRef,
    src: props.placeholderSrc
  }));
  useInView(imageRef, function () {
    setInView(true);
  }, []);

  if (inView) {
    return React.createElement(React.Fragment, null, !isLoaded && placeholder, lazyImage);
  }

  return placeholder;
}

LazyImage.propTypes = propTypes;
export default function Image(_ref2) {
  var props = _extends({}, _ref2);

  return props.placeholderSrc ? React.createElement(LazyImage, props) : React.createElement(StyledImage, props);
}
Image.propTypes = propTypes;